import { InjectionToken } from '@angular/core';

class GoogleAuthConfig {
    constructor(options) {
        Object.assign(this, options);
    }
}
class LoginComponentLink {
    constructor(linkHtml, routerLinkPath) {
        this.linkHtml = linkHtml;
        this.routerLinkPath = routerLinkPath;
    }
}
/**
 * Token used for providing the ILoginModuleConfig
 * @example
 * // in the app or shared modules providers section
 * providers: [
 *     { provide: LoginModuleConfigToken, useValue: loginModuleConfig },
 * ],
 */
const LoginModuleConfigToken = new InjectionToken('login_module_config');

/**
 * Token used for providing an override to the auth service to be used
 * in the login module
 * @example
 * // in the app or shared modules providers section
 * providers: [
 *     { provide: LoginModuleOverrideAuthServiceToken, useExisiting: LoginModuleOverridenAuthService },
 * ],
 */
const LoginModuleOverrideAuthServiceToken = new InjectionToken('login_override_auth_service');

const Constants = {
    OFFLINE_ACCESS_SCOPE: 'offline_access',
    OPENID_SCOPE: 'openid',
    PROFILE_SCOPE: 'profile',
};
const OPEN_IDENTITY_CONNECT_DEFAULT_SCOPES = [Constants.OPENID_SCOPE, Constants.PROFILE_SCOPE, Constants.OFFLINE_ACCESS_SCOPE];
class MicrosoftAuthConfig {
    constructor(options) {
        var _a;
        Object.assign(this, options);
        // Add default scopes to passed in scopes if provided
        this.additionalScopes = ((_a = options.additionalScopes) === null || _a === void 0 ? void 0 : _a.concat(...OPEN_IDENTITY_CONNECT_DEFAULT_SCOPES)) || OPEN_IDENTITY_CONNECT_DEFAULT_SCOPES;
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { Constants, GoogleAuthConfig, LoginComponentLink, LoginModuleConfigToken, LoginModuleOverrideAuthServiceToken, MicrosoftAuthConfig, OPEN_IDENTITY_CONNECT_DEFAULT_SCOPES };

//# sourceMappingURL=mt-ng2-login-module-config.js.map